import { IFirm } from "../../models/IFirm";
import { IFirmData } from "../../models/IFirmData";
import { IFirmTradeLimit } from "../../models/IFirmTradeLimit";

export class FirmsState {
  list: IFirm[] = [];
  firmsData: IFirmData[] = [];
  firmTradeLimits: IFirmTradeLimit[] = [];
}
